import { APP_CONFIG } from '../../app.config';

export const WELCOME_CONFIG = {
  requests: {
    welcome: {
      name: 'welcome',
      url: `${APP_CONFIG.apiBaseUrl}/account/welcome`,
    },
    checkToken: {
      name: 'checkToken',
      url: `${APP_CONFIG.apiBaseUrl}/account/check-token`,
    },
  },
};
